import { memo } from 'react';

import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

const typeMap = {
  blue: dynamic(() => import('./Blue')),
  yellow: dynamic(() => import('./Yellow'))
};

const Tab = memo(({ type, ...rest }) => {
  const Component = typeMap[type];

  return <Component {...rest} />;
});

Tab.displayName = 'Tab';

Tab.propTypes = {
  type: PropTypes.oneOf(['blue', 'yellow'])
};

Tab.defaultProps = {
  type: 'blue'
};

export default Tab;
